/**
 * The league's 30 clubs, by the codes the site uses. A game can have a side
 * that is none of them, a touring club in the preseason or an All-Star squad
 * (DSPRT-364, #117): that side has a name and a score and no page behind it.
 */
const CLUBS = new Set([
  "ATL", "BKN", "BOS", "CHA", "CHI", "CLE", "DAL", "DEN", "DET", "GSW",
  "HOU", "IND", "LAC", "LAL", "MEM", "MIA", "MIL", "MIN", "NOP", "NYK",
  "OKC", "ORL", "PHI", "PHX", "POR", "SAC", "SAS", "TOR", "UTA", "WAS",
]);

export const isClub = (abbr: string | null | undefined): boolean => !!abbr && CLUBS.has(abbr.toUpperCase());

/** ESPN's code for a side it has not decided yet: a Cup knockout slot before the groups finish, a playoff slot (#123). */
export const UNDECIDED = "TBD";

/** A game with a side still to be decided. It has a day and a round and nothing else: no tip-off time, no preview, no reminder. */
export const isUndecided = (g: { home: { abbr: string }; away: { abbr: string } }): boolean =>
  g.home.abbr === UNDECIDED || g.away.abbr === UNDECIDED;
